import "../styles/style.css";
import "../styles/light-mode.css";
import Title from "./Title";
import TypingEffect from "./TypingEffect"

import { useState } from "react";
import { useTranslation } from "react-i18next"

export default function SectionTwo() {

    const { t } = useTranslation();
    
    const [showToast, setShowToast] = useState(false);

    return (
        <section className="section sec-2">

            <Title id={"about"} title={t("title-about-me.about-me")} />

            <div className="container container-2">
                <div data-aos="fade-right" className="my-name">


                    <TypingEffect
                        texts={[
                            t("typing.text1"),
                            t("typing.text2"),
                        ]}
                        
                    />

                    <p className="hero-text">
                        {t("hero-text.text")}
                    </p>

                    <div className="btn-div-download">
                        <a
                            href="https://api.whatsapp.com/send?phone=201063680423"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn-click whatsApp-btn">
                                <i className="fa-brands fa-whatsapp"></i>
                                <p>{t("Get-in-touch.text")}</p>
                            </button>
                        </a>

                        <a href="#cv"
                            onClick={() => {
                                setShowToast(true);
                                setTimeout(() => {
                                    setShowToast(false);
                                }, 3000);
                            }}>
                            <button className="btn-click download-btn">
                                <i className="fa-solid fa-cloud-arrow-down"></i>
                                {t("Download-cv.text")}
                            </button>
                        </a>
                    </div>
                </div>

                <div data-aos="fade-left" className="hello-photo">
                    <img alt="robot" className="robot" src="/assets/images/robot1.png"/>
                </div>
            </div>

            {showToast && (
                <div className="success-toast">
                    <p>{t("toast.text")}</p>
                </div>
            )}

        </section>
    );
}